'use client';

import { toast as sonnerToast } from 'sonner';

export const toastStyles = {
  default: {
    light: {
      backgroundColor: '#FFFFFF',
      border: '1px solid #E5E7EB',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
      color: '#1F2937',
    },
    dark: {
      backgroundColor: '#1F2937',
      border: '1px solid #374151',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.3)',
      color: '#F3F4F6',
    },
  },
  success: {
    light: {
      backgroundColor: '#F0FDF4',
      border: '1px solid #BBF7D0',
      color: '#166534',
    },
    dark: {
      backgroundColor: '#064E3B',
      border: '1px solid #065F46',
      color: '#A7F3D0',
    },
  },
  error: {
    light: {
      backgroundColor: '#FEF2F2',
      border: '1px solid #FECACA',
      color: '#991B1B',
    },
    dark: {
      backgroundColor: '#7F1D1D',
      border: '1px solid #991B1B',
      color: '#FCA5A5',
    },
  },
};

type ToastVariant = keyof typeof toastStyles;

interface ToastOptions {
  variant?: ToastVariant;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function Toast({ variant = 'default', ...props }: ToastOptions) {
  // Check if we're in dark mode
  const isDark = document.documentElement.classList.contains('dark');
  const style = toastStyles[variant][isDark ? 'dark' : 'light'];

  return sonnerToast(props.title, {
    style,
    description: props.description,
    action: props.action
      ? {
          label: props.action.label,
          onClick: props.action.onClick,
        }
      : undefined,
  });
}
